import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const addAdmin = createAsyncThunk('admin/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/admin/admin/register`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editAdmin = createAsyncThunk('admin/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/admin/update-admin/${data?.admin_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const updateAdminActivation = createAsyncThunk('admin/activation', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/admin/update-activation-status/${data?.adminID}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteAdmin = createAsyncThunk('admin/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/admin/admin/delete-admin/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllAdmin = createAsyncThunk('admin/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/admin/get-all-admin`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllAdminRole = createAsyncThunk('admin/allRole', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/admin/get-admin-types`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAdminByID = createAsyncThunk('admin/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/admin/get-admin/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAdminByRegion = createAsyncThunk('admin/getByRegion', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/admin/get-admin-by-region/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addRegionalAdmin = createAsyncThunk('admin/addREginalAdmin', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/admin/auth/region-set-admin`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allAdmin: [],
  allAdminByRegion: [],
  allAdminRole: [],
  getAdmin: null,
  admin: null,
  error: null
}

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.user = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAdmin.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addAdmin.fulfilled, (state, action) => {
        state.isLoading = false
        state.admin = action.payload?.data?.data
      })
      .addCase(addAdmin.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editAdmin.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editAdmin.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.admin = payload?.data
      })
      .addCase(editAdmin.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(updateAdminActivation.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateAdminActivation.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(updateAdminActivation.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deleteAdmin.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteAdmin.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteAdmin.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllAdmin.pending, (state) => {
        state.isLoading = true
        state.allAdmin = []
      })
      .addCase(getAllAdmin.fulfilled, (state, action) => {
        state.isLoading = false
        state.allAdmin = action.payload?.data?.data
      })
      .addCase(getAllAdmin.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllAdminRole.pending, (state) => {
        state.isLoading = true
        state.allAdminRole = []
      })
      .addCase(getAllAdminRole.fulfilled, (state, action) => {
        state.isLoading = false
        state.allAdminRole = action.payload?.data?.data
      })
      .addCase(getAllAdminRole.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAdminByID.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAdminByID.fulfilled, (state, action) => {
        state.isLoading = false
        state.getAdmin = action.payload?.data?.data
      })
      .addCase(getAdminByID.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAdminByRegion.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAdminByRegion.fulfilled, (state, action) => {
        state.isLoading = false
        state.allAdminByRegion = action.payload?.data?.data
      })
      .addCase(getAdminByRegion.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.allAdminByRegion = []
      })
      .addCase(addRegionalAdmin.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addRegionalAdmin.fulfilled, (state) => {
        state.isLoading = false
        // state.admin = action.payload?.data?.data
      })
      .addCase(addRegionalAdmin.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = adminSlice.actions
export default adminSlice.reducer
